import { SelectedTagProps, SelectedTagsProps } from "../ProductList.types";
import * as React from "react";

const SelectedTags: React.FC<SelectedTagsProps> = (props) => {
    return (
        <div className="tmp-product-list__selected-tags">
            <div
                className="tmp-product-list__selected-tags__item"
                onClick={() => {
                    props.resetFilters();
                }}
            >
                <div className="tmp-product-list__selected-tags__item-content">
                    <span>{props.resetFiltersText ? props.resetFiltersText : ""}</span>
                    <i className="fas fa-trash"></i>
                </div>
            </div>
            {props.tags_raw
                .filter((tag) => props.selected_tags.includes(tag.id))
                .map((tag) => (
                    <SelectedTag key={tag.id} tag={tag} onTagChange={props.onTagChange} />
                ))}
        </div>
    );
};

const SelectedTag: React.FC<SelectedTagProps> = (props) => {
    return (
        <div
            className="tmp-product-list__selected-tags__item"
            onClick={() => {
                props.onTagChange(props.tag);
            }}
        >
            <div className="tmp-product-list__selected-tags__item-content">
                <span>{props.tag.name}</span>
                <i className="fas fa-times"></i>
            </div>
        </div>
    );
};

export default SelectedTags;
